import { useCallback, useEffect } from 'react';
import { AmplitudeAnalyticsEvent, EventProperties } from 'core/analytics/entities';
import { useServices } from 'core/common/hooks';

type Params = Partial<{
  baseEventProperties: EventProperties;
}>;

export const useAnalytics = (analytics?: Partial<AmplitudeAnalyticsEvent>, params?: Params) => {
  const { analyticsService } = useServices();

  const trackClickEvent = (properties?: EventProperties) => {
    if (!analytics?.clickEvent) {
      return;
    }

    analyticsService.trackEvent(analytics.clickEvent, properties);
  };

  const trackSkipEvent = (properties?: EventProperties) => {
    if (!analytics?.skipEvent) return;

    analyticsService.trackEvent(analytics.skipEvent, properties);
  };

  const trackGetOfferEvent = (properties?: EventProperties) => {
    if (!analytics?.getOfferEvent) return;

    analyticsService.trackEvent(analytics.getOfferEvent, properties);
  };

  const trackCustomEvent = (name: string, properties?: EventProperties) => {
    analyticsService.trackEvent(name, properties);
  };

  const updateUserProperties = useCallback(
    (properties: EventProperties) => {
      analyticsService.updateUserProperties(properties);
    },
    [analyticsService],
  );

  useEffect(() => {
    if (!analytics?.baseEvent) return;

    analyticsService.trackEvent(analytics.baseEvent, params?.baseEventProperties);
  }, [analyticsService, analytics, params]);

  return {
    trackClickEvent,
    trackSkipEvent,
    trackGetOfferEvent,
    trackCustomEvent,
    updateUserProperties,
  };
};
